var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7618 13.5206C7.60851 13.5206 5.05226 10.9644 5.05226 7.8111C5.05226 4.65781 7.60851 2.10156 10.7618 2.10156C13.9151 2.10156 16.4713 4.65781 16.4713 7.8111C16.4713 10.9644 13.9151 13.5206 10.7618 13.5206Z",
    fill: "#0FAF71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2215 16.4609C11.7447 16.4046 11.2571 16.3754 10.7612 16.3754C5.25425 16.3754 0.769531 19.9724 0.769531 24.4044C0.769531 24.7042 1.01135 24.9397 1.31913 24.9397H16.4327C13.4349 22.5639 12.4082 19.0624 12.2215 16.4609Z",
    fill: "#0FAF71"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4765 14.3085L20.6763 12.1674C20.9233 12.0648 21.2006 12.0648 21.4476 12.1674L26.6473 14.3085C27.0416 14.4735 27.3016 14.866 27.3016 15.3032C27.3016 18.1267 26.1793 22.8326 21.4649 24.8577C21.2093 24.9692 20.9189 24.9692 20.6633 24.8577C15.9445 22.8326 14.8222 18.1267 14.8222 15.3032C14.8222 14.866 15.0822 14.4735 15.4765 14.3085Z",
    fill: "#0FAF71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminV2);
export default __webpack_public_path__ + "static/media/admin-v2.df6c0888c36cadc17dbcfc916646ef03.svg";
export { ForwardRef as ReactComponent };